import React, { useEffect, useState } from "react"

import { wowPartnerApi } from "../../../@shared/apis"
import { PartnerStockComment } from "../../../@shared/apis/wowPartner"
import { usePartenerTradeStrategy } from "../../../@shared/stores/partnerStore"
import iconListImg from "@shared/assets/images/icon-list.png"
import iconSms from "../../../@shared/assets/images/icon-sms.png";
import {toYYYYMMDDHHmm} from "../../modules";

const StockStrategy = () => {
  const { isOpenTradeStrategy, strategyItemSeq, setIsOpenTradeStrategy } =
    usePartenerTradeStrategy()
  const [stockComment, setStockComment] = useState<PartnerStockComment[]>([])

  useEffect(() => {
    wowPartnerApi
      .getPartnerStockComment(strategyItemSeq || "0")
      .then((result) => {
        setStockComment(result.data.commentList)
      })
  }, [strategyItemSeq])

  return (
    <>
      <div
        className="news_title"
        onClick={() => {
          setIsOpenTradeStrategy(!isOpenTradeStrategy)
        }}
        style={{
          cursor: "pointer",
        }}
      >
        종목 전략
        <div
          style={{
            width: "20px",
            marginTop: `${isOpenTradeStrategy ? 8 : 12}px`,
            marginLeft: "10px",

          }}
        >
          <div
            style={{
              borderLeft: "solid 1px #000",
              borderTop: "solid 1px #000",
              rotate: `${isOpenTradeStrategy ? "225deg" : "45deg"}`,
              width: "8px",
              height: "8px",
            }}
          />
        </div>
      </div>
      {isOpenTradeStrategy && (
        <div className="news_item_wrap">
          {stockComment.map((comment, index) => (
            <div key={comment.comment} className="news_item">
              <img
                src={iconListImg}
                style={{width: "28px", paddingTop: "2px"}}
                alt="stock"
              />
              [{toYYYYMMDDHHmm(comment.regdate)}] {comment.comment}
            </div>
          ))}


          {stockComment.length === 0 && (
            <div className="news_item" style={{
              color: "#999",
            }}>아직 등록된 내용이 없습니다.</div>
          )}
        </div>


      )}
    </>
  )
}
export default StockStrategy
